module.exports = __webpack_public_path__ + "static/media/lots2.e1cd183c.jpg";